import { useQuery } from '@hooks/reactQuery';

import { getMavenirConfigIds } from '@api/dataSources';

import { optionsFormattedWithArray } from '@utils/formatter';

import { TSelectOption } from '@interfaces/components/componentTypes';

import { refetchOptions } from '@constants/common';
import { MAVENIR_CONFIG_IDS } from '@constants/queryKeys';

interface IMavenirConfigIdOptionsReturnType {
	idsOptions: TSelectOption<string>[];
	isLoadingIdsOptions: boolean;
}

const useQueryMavenirConfigIdOptions = (): IMavenirConfigIdOptionsReturnType => {
	const {
		data,
		isLoading,
		isFetching,
	} = useQuery<string[], TSelectOption<string>[]>({
		queryKey: [MAVENIR_CONFIG_IDS],
		queryFn: getMavenirConfigIds,
		select: (items) => {
			const sortedItems = items.sort((a, b) => Number(a) - Number(b));

			return optionsFormattedWithArray(sortedItems);
		},
		...refetchOptions,
	});

	return {
		idsOptions: data || [],
		isLoadingIdsOptions: isLoading || isFetching,
	};
};

export default useQueryMavenirConfigIdOptions;
